import classNames from 'classnames';
import styles from './NewsCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_ArticleDate } from '../../Article/ArticleDate/ArticleDate';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface NewsCardProps {
	className?: string;
	image?: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	imageCropping?: 'cover' | 'contain';
	altText?: string;
	url?: string;
	date: string;
	kicker: string;
	heading: string;
	text: string;
}

export const UI_NewsCard = ({ className, image, url, altText, heading, text, date, imageCropping }: NewsCardProps) => {
	const contentInner = (
		<>
			<UI_Link className={styles.NewsCard_link} title={heading} url={url}>
				{image && (
					<div className={styles.NewsCard_media}>
						<span className={styles.NewsCard_mediabox}>
							<UI_Picture
								imageRatio={0.5625}
								url={image.url}
								altText={altText}
								focalPoint={image.focalPoint}
								sizes="(min-width:768px) 50vw, 100vw"
								imageCropping={imageCropping}
							/>
						</span>
					</div>
				)}
				<div className={styles.NewsCard_textbox}>
					<UI_ArticleDate date={date} spacing="Small" />
					<UI_Heading className={styles.NewsCard_heading} headingLevel="h3" style="sm">
						{heading}
					</UI_Heading>
					<div className={styles.NewsCard_text} dangerouslySetInnerHTML={{ __html: text }}></div>
				</div>
			</UI_Link>
		</>
	);

	const content = <div className={classNames(styles.NewsCard, className)}>{contentInner}</div>;

	return content;
};
